// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import baseSettings from "./baseEnvironment";

export const environment = {
  production: true,
  urlServer: 'https://demo-e-signe-front-api.azurewebsites.net/api/',
  processAPI: 'https://demo-e-signe-process-api.azurewebsites.net/api/',
  appVersion: baseSettings.appVersion,
  displayESigneLogoOnPopup:false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * 
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
